import React from 'react'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { keyPickUrl, publishedCaKeyPicks } from 'services/CurrentAwarenessService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import KeyPicks from 'components/shared/KeyPicks'

const CaKeyPicks = ({ aol, isLogged, setSignUpModalIsOpen }) => {
  const keyPicks = useObservable(
    publishedCaKeyPicks({ aol, prepay: false }),
    RESPONSE_PENDING
  )
  const handleOnClick = (e) => {
    if (!isLogged) {
      e.preventDefault()
      setSignUpModalIsOpen(true)
    }
  }
  const cxNames = { tile: { borderColor: 'b--dark-cerulean' } }
  const props = {
    cxNames,
    keyPicks,
    handleOnClick,
    iconName: 'icon-file-document',
    className: 'pt8 mb2',
    itemClassName: 'b--light-sea-green-2',
    getUrl: ({ articleId: id }) => keyPickUrl(id, aol),
    getItemDataAttributes: ({ title, articleId }) => ({
      'data-event-category': 'Current Awareness Key Picks',
      'data-event-action': 'Click',
      'data-event-label': `[${title}] : [${articleId}]`,
      'data-event-aol': aol
    })
  }

  return (
    <ResponseConsumer
      response={keyPicks}
      pendingComponent={() => <KeyPicks {...props} pending />}
      content={() => <KeyPicks {...props} />}
    />
  )
}

export default CaKeyPicks
